import { createFileRoute } from "@tanstack/react-router";
import AccountPage from "@project/user/pages/account/index";

export const Route = createFileRoute("/_user/account")({
  head: () => ({ meta: [{ title: "My Account — Jivandhara" }] }),
  component: AccountPage,
});
